import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import styled from 'styled-components';
import { Flex, Grid } from '../../Utils/styles/display';
import Image from '../../atomic/atoms/Image';
import KnowledgeCenterCard from '../../atomic/molecules/KnowledgeCenterCard';
import FilePreviewModal from '../../atomic/molecules/FilePreviewModal';
import useKnowledgeCenterController from './useKnowledgeCenterController';
import KnowledgeCenterLoadingImage from '../../img/opening-folder.gif';
import KnowledgeCenterErrorImage from '../../img/error.svg';
import KnowledgeCenterEmptyImage from '../../img/group-waiting.svg';
import {
  KNOWLEDGE_CENTER_LOADING,
  KNOWLEDGE_CENTER_LOADING_SUB,
  KNOWLEDGE_CENTER_EMPTY,
  KNOWLEDGE_CENTER_EMPTY_SUB,
  KNOWLEDGE_CENTER_ERROR,
  KNOWLEDGE_CENTER_ERROR_SUB,
} from '../../languages/en/header';
import Body from '../../atomic/atoms/Body';
import useLayoutStore from '../../stores/layoutStore';
import { LayoutStoreState } from '../../interfaces/Layout';
export const StyledImage = styled(Image)`
  margin: 48px 0;
`;

const layoutSelector = (state: LayoutStoreState) =>
  state.setRightAsideOpenToFalse;

const KnowledgeCenterController = () => {
  const {
    isLoading,
    data,
    selectedFile,
    fileToPreview,
    hasNextPage,
    handleFetchNextPage,
    handleSetSelectedFile,
    onDownloadFileClick,
    copyPostLink,
  } = useKnowledgeCenterController();
  const [modalOpen, setModalOpen] = useState(false);

  const setRightAsideOpenToFalse = useLayoutStore(layoutSelector);

  useEffect(() => {
    setRightAsideOpenToFalse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <Flex flexDirection="column" alignItems="center" margin="32px 0 0">
        <StyledImage
          alt={KNOWLEDGE_CENTER_LOADING}
          src={KnowledgeCenterLoadingImage}
        />

        <Body variant="subHead2Bold">{KNOWLEDGE_CENTER_LOADING}</Body>

        <Body variant="body1">{KNOWLEDGE_CENTER_LOADING_SUB}</Body>
      </Flex>
    );
  } else if (data?.pages?.length === 0) {
    return (
      <Flex flexDirection="column" alignItems="center" margin="32px 0 0">
        <StyledImage
          alt={KNOWLEDGE_CENTER_EMPTY}
          src={KnowledgeCenterEmptyImage}
        />

        <Body variant="subHead2Bold">{KNOWLEDGE_CENTER_EMPTY}</Body>

        <Body variant="body1" style={{ width: '315px' }}>
          {KNOWLEDGE_CENTER_EMPTY_SUB}
        </Body>
      </Flex>
    );
  } else if (!data) {
    return (
      <Flex flexDirection="column" alignItems="center" margin="32px 0 0">
        <StyledImage
          alt={KNOWLEDGE_CENTER_ERROR}
          src={KnowledgeCenterErrorImage}
        />

        <Body variant="subHead2Bold">{KNOWLEDGE_CENTER_ERROR}</Body>

        <Body variant="body1">{KNOWLEDGE_CENTER_ERROR_SUB}</Body>
      </Flex>
    );
  } else {
    return (
      <>
        <InfiniteScroll
          next={handleFetchNextPage}
          dataLength={data.pages.length}
          hasMore={Boolean(hasNextPage)}
          style={{ overflow: 'inherit' }}
          scrollableTarget="scrollableFeedContent"
          loader={undefined}
        >
          <Grid columnGap={'16px'} rowGap={'16px'}>
            {data.pages.map((page) => (
              <>
                {page.data.map((card) => (
                  <KnowledgeCenterCard
                    key={
                      card.response.blockId +
                      card.fileInfo.name +
                      card.response.responseId
                    }
                    card={card}
                    handleSetSelectedFile={handleSetSelectedFile}
                    openPreviewer={setModalOpen}
                    onClickDownload={(cardFile) =>
                      onDownloadFileClick(cardFile)
                    }
                    copyPostLink={copyPostLink}
                  />
                ))}
              </>
            ))}
          </Grid>
        </InfiniteScroll>
        <FilePreviewModal
          person={selectedFile?.respondent}
          createdAt={selectedFile?.fileInfo.createdAt}
          fileInformation={selectedFile?.fileInfo}
          fileToPreview={fileToPreview}
          isOpen={modalOpen}
          onClickDownload={() => onDownloadFileClick(selectedFile)}
          onCloseModal={() => {
            setModalOpen(false);
            handleSetSelectedFile(undefined);
          }}
          flow={selectedFile?.flowInfo}
          visibility={selectedFile?.flowInfo.visibility}
        />
      </>
    );
  }
};

export default KnowledgeCenterController;
